import React, { useContext, useState } from 'react'
import "./topbar.css"
import { Link, useNavigate } from 'react-router-dom'
import { Context } from '../../context/Context'
import Pointer from '../pointer/Pointer'
import { useEffect } from 'react';

function TopBar() {
  const PF = "https://mernblogbackend.onrender.com/images/"
  const { user, dispatch } = useContext(Context);
  const [input, setInput] = useState("");
  const [pointer, setPointer] = useState(false);
  const navigate = useNavigate();


  const handleLogout = () => {
    dispatch({ type: "LOGOUT" });
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      navigate('/?user=' + input);
    }
  }

  // useEffect(() => {
  //   if (user.profilePic === "") {
  //     setPointer(true);
  //   }
  // },[])



  console.log(pointer);
  return (
    <div className="top">
      {/* {pointer && <Pointer setPointer={setPointer} />} */}
      <img src="https://image.pngaaa.com/748/1993748-middle.png" className='topbarLogo'></img>
      <div className='topLeft'>
        <Link to="https://www.linkedin.com/in/sayan-kar-9b1aa8254/">
          <i className="topIcon fa-brands fa-linkedin"></i>
        </Link>
        <Link to="https://www.facebook.com/profile.php?id=100073863231661">
          <i className="topIcon fa-brands fa-facebook"></i>
        </Link>
        <Link to="https://github.com/Sayan599">
          <i className="topIcon fa-brands fa-github"></i>
        </Link>
      </div>
      <div className='topCentre'>
        <ul className="topList">
          <li className='topListItem'><Link className="link" to="/">HOME</Link></li>
          <li className='topListItem'><Link className="link" to="/">ABOUT</Link></li>
          <li className='topListItem'><Link className="link" to="/">CONTRACT</Link></li>
          <li className='topListItem'><Link className="link" to="/write">WRITE</Link></li>
          <li className='topListItem' onClick={handleLogout}>
            {user && "LOGOUT"}
          </li>
        </ul>
      </div>
      <div className='topRight'>
        {
          user ? (
            <>
              <div>Hi, {user?.username} </div>
              <Link to="/settings">
                {user?.profilePic ? (<img className='topImg' src={PF + user?.profilePic} alt="" ></img>) : <i className="topImg fa-solid fa-user-astronaut"></i>}
              </Link>
            </>
          )
            :
            (
              <>
                <ul className="topList">
                  <li className='topListItem'><Link className='link' to="/login">LOGIN</Link></li>
                  <li className='topListItem'><Link className='link' to="/register">REGISTER</Link></li>
                </ul>
              </>
            )
        }

        <i className="topSearchIcon  fa-solid fa-magnifying-glass"></i>
        <input className='topSearch' placeholder="search by post author.." spellCheck={false} type="text" onKeyDown={handleKeyDown} onChange={(e) => setInput(e.target.value)}></input>
      </div>
    </div>
  )
}

export default TopBar